<!-- 课程管理 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <CourseForm @onCourseAddChangeSelect="setCourseAddData"></CourseForm>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="publish">发布</el-button>
      <el-button style="margin-top: 12px;" type="info" @click="temporaty">暂存</el-button>
    </el-card>
  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import { courseAddApi } from "@/api/module/course/course";
import { CourseForm } from "@/views/module/course/comp/";

export default {
  name: "CourseAdd",
  
  mixins: [BaseVue],
  
  components: {
    CourseForm
  },
  
  data() {
    return {
      title: "",
      teacher: "",
      description: "",
      loading: false,
      status: "",
      sid: "",
      activityType: "0"
    };
  },
  
  methods: {
    // extend 获取子组件数据
    setCourseAddData(e) {
      this.title = e.title;
      this.teacher = e.teacher;
      this.description = e.description;
      this.sid = e.sid;
      this.activityType = e.activityType;
    },
    
    // 发布
    publish() {
      this.loading = true;
      this.status = "0";
      this.addDemo();
    },
    
    // 暂存
    temporaty() {
      this.loading = true;
      this.status = "1";
      this.addDemo();
    },
    
    addDemo() {
      if (!this.title) {
        this.$message.error("请填写课程名称！");
        this.loading = false;
        return false;
      }
      
      const data = {
        title: this.title,
        description: this.description,
        teacher: this.teacher,
        status: this.status,
        sid: this.sid,
        type: this.activityType
      };
      
      courseAddApi(data)
        .then(response => {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          setTimeout(() => {
            this.$router.replace({
              path: "/course/dashboard"
            });
          }, 1500);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  
  mounted() {
    // 组件挂载后的逻辑
  }
};
</script>

<style scoped lang="scss">
.form_box {
  .form_box__item {
    margin-bottom: 15px;
    font-size: 14px;
    color: #303133;
    span {
      margin-right: 50px;
      white-space: nowrap;
    }
    .form_box__item__input {
      margin-left: 0;
    }
  }
}
::v-deep .el-input--suffix .el-input__inner{
  width: 320px;
}
::v-deep .form_box__group__item .form_box__group__item__content{
  width: 320px;
}
</style>

